import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../lib/api';
import { CreateLocationPayload, UpdateLocationPayload } from './types';

export * from './types';

export const qk = {
  locations: ['organization', 'locations'] as const,
};

export function useListLocations() {
  return useQuery({
    queryKey: qk.locations,
    queryFn: async () => {
      const resp = await api.get('/organization/locations');
      return resp.data?.locations ?? resp.data ?? [];
    },
  });
}

export function useListAvailableLocations() {
  return useQuery({
    queryKey: qk.locations,
    queryFn: async () => {
      const resp = await api.get('/organization/locations/available');
      return resp.data?.locations ?? resp.data ?? [];
    },
  });
}

export function useCreateLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: CreateLocationPayload) => {
      const resp = await api.post('/organization/locations', payload);
      return resp.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.locations });
      qc.invalidateQueries({ queryKey: ['users', 'me'] });
      qc.invalidateQueries({ queryKey: ['auditLogs'] });
    },
  });
}

export function useUpdateLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: UpdateLocationPayload) => {
      const resp = await api.put(`/organization/locations/${id}`, data);
      return resp.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.locations });
      qc.invalidateQueries({ queryKey: ['auditLogs'] });
    },
  });
}

export function useArchiveLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const resp = await api.post(`/organization/locations/${id}/archive`);
      return resp.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.locations });
      qc.invalidateQueries({ queryKey: ['auditLogs'] });
    },
  });
}

export function useUnarchiveLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const resp = await api.post(`/organization/locations/${id}/unarchive`);
      return resp.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.locations });
      qc.invalidateQueries({ queryKey: ['auditLogs'] });
    },
  });
}
